import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function MilesStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M23.4431 13.9211L21.6612 5.62411C21.4941 4.78885 20.9929 4.12063 20.3247 3.67516C19.6008 3.22968 18.7656 3.06263 17.986 3.22968L2.95118 6.40369C1.28065 6.7378 0.166961 8.40834 0.556752 10.1346L2.33865 18.3759C2.50571 19.2111 3.00687 19.8793 3.67508 20.3248C4.12056 20.6032 4.6774 20.826 5.23425 20.826C5.28993 20.826 5.34561 20.826 5.4013 20.826C5.62404 20.826 5.84678 20.826 6.06951 20.7703L21.0486 17.5963C21.8839 17.4292 22.5521 16.9281 22.9976 16.2598C23.4431 15.5359 23.6101 14.7007 23.4431 13.9211ZM4.45466 19.1554C4.06487 18.9327 3.78645 18.5429 3.73077 18.0974L1.94886 9.80045C1.72613 8.9095 2.33865 7.96286 3.28529 7.79581L18.2644 4.62179C18.3758 4.62179 18.4871 4.56611 18.5985 4.56611C18.9326 4.56611 19.2667 4.67748 19.5451 4.84453C19.9349 5.06727 20.2134 5.45706 20.269 5.90253L22.0509 14.1995C22.1623 14.645 22.051 15.0905 21.8282 15.4803C21.5498 15.8701 21.2157 16.1485 20.7702 16.2042L5.79109 19.3782C5.28993 19.4895 4.84446 19.4339 4.45466 19.1554Z"
				fill="currentColor"
			/>
			<path
				d="M11.805 11.5267C11.8607 11.471 11.9721 11.471 12.0278 11.471L13.2528 11.8051C13.5312 11.8608 13.6426 11.7494 13.5312 11.471L13.0301 10.3016C13.0301 10.2459 13.0301 10.1346 13.0301 10.0789L13.754 9.02087C13.921 8.79813 13.8097 8.63107 13.5312 8.63107L12.2505 8.68676C12.1948 8.68676 12.0834 8.63107 12.0278 8.57539L11.2482 7.57307C11.0811 7.35033 10.9141 7.40602 10.8027 7.68444L10.58 8.96518C10.58 9.02087 10.5243 9.13223 10.4129 9.13223L9.18784 9.57771C8.90942 9.68908 8.90942 9.85613 9.13216 10.0232L10.1902 10.6914C10.2458 10.7471 10.3015 10.8028 10.3015 10.8585L10.3572 12.1392C10.3572 12.4176 10.5243 12.4733 10.747 12.3062L11.805 11.5267Z"
				fill="currentColor"
			/>
			<path
				d="M9.18784 17.0394L8.85374 15.3689L8.24121 16.594H8.18552L7.1832 15.703L7.51731 17.3735L6.73773 17.5406L6.1252 14.645L6.96046 14.4779L8.01847 15.3689L8.57531 14.1438L9.3549 13.9768L10.0231 16.8724L9.18784 17.0394Z"
				fill="currentColor"
			/>
			<path
				d="M10.7577 13.6424L9.94074 13.8161L10.5659 16.7572L11.3829 16.5835L10.7577 13.6424Z"
				fill="currentColor"
			/>
			<path
				d="M11.9721 16.4269L11.3595 13.5313L12.1391 13.3643L12.5846 15.5916L13.754 15.3689L13.921 16.0371L11.9721 16.4269Z"
				fill="currentColor"
			/>
			<path
				d="M14.3108 15.9257L13.6983 13.0301L15.7586 12.5847L15.87 13.3086L14.6449 13.5313L14.7006 13.9768L15.9257 13.754L16.037 14.3666L14.8677 14.645L14.979 15.0905L16.2041 14.812L16.3711 15.5359L14.3108 15.9257Z"
				fill="currentColor"
			/>
			<path
				d="M17.095 14.0325C16.7609 13.9768 16.3711 13.8097 16.2598 13.3643C16.1484 12.8631 16.5382 12.3619 17.2621 12.2506C17.7076 12.1392 18.0974 12.2506 18.3758 12.3619L18.0974 12.9745C17.8746 12.8631 17.6519 12.8631 17.4291 12.8631C17.2064 12.9188 17.095 13.0301 17.095 13.1415C17.095 13.2529 17.2064 13.2529 17.3178 13.3086L17.986 13.4199C18.4315 13.5313 18.7099 13.6984 18.8213 14.0882C18.9326 14.5893 18.5428 15.0905 17.8189 15.2575C17.3735 15.3689 16.928 15.2575 16.5382 15.0905L16.7609 14.4223C17.0394 14.5336 17.3735 14.645 17.5962 14.5893C17.8189 14.5336 17.9303 14.4223 17.8746 14.3109C17.8746 14.1995 17.7632 14.1995 17.6519 14.1438L17.095 14.0325Z"
				fill="currentColor"
			/>
		</svg>
	);
}

MilesStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default MilesStrokeIcon;
